import { Title } from '@angular/platform-browser';
import { Injectable, Injector, inject } from '@angular/core';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { BreadcrumbService } from './breadcrumb.service';

const APP_NAME = 'RX Africa';

/**
 * Sets the browser tab title from the breadcrumb trail, so a tab reads
 * "Order Form · Acme Ltd · Cape Expo 2026 — RX Africa" instead of a static app name.
 *
 * Calls BreadcrumbService.build() synchronously rather than subscribing to
 * `breadcrumbs$`: both this strategy and that service react to the same
 * NavigationEnd, and their subscription order is not guaranteed.
 */
@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
    private _title = inject(Title);

    /**
     * Resolved lazily rather than injected directly: the Router constructs its
     * TitleStrategy, and BreadcrumbService depends on the Router, so injecting it
     * here eagerly is a circular dependency (NG0200). By the time updateTitle runs
     * the Router exists, so resolving on demand is safe.
     */
    private _injector = inject(Injector);

    override updateTitle(_snapshot: RouterStateSnapshot): void {
        const trail = this._injector
            .get(BreadcrumbService)
            .build()
            .map((crumb) => crumb.label)
            .reverse();

        this._title.setTitle(trail.length > 0 ? `${trail.join(' · ')} — ${APP_NAME}` : APP_NAME);
    }
}
